import { useState, useCallback } from "react";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WorkInfo from "./components/WorkInfo";
import TrustCard from "./components/TrustCard";
import Benefits from "./components/Benefits";
import Footer from "./components/Footer";
import ContactModal from "./components/ContactModal";

function App() {
    const [contactOpen, setContactOpen] = useState(false);
    const openContact = useCallback(() => setContactOpen(true), []);
    const closeContact = useCallback(() => setContactOpen(false), []);

    return (
        <div className="App" data-testid="app-root">
            <Header onContact={openContact} />
            <main>
                <Hero onContact={openContact} />
                <WorkInfo />
                <TrustCard />
                <Benefits />
            </main>
            <Footer />
            <ContactModal open={contactOpen} onClose={closeContact} />
        </div>
    );
}

export default App;
